import * as tslib_1 from "tslib";
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import classNames from 'classnames';
import FormControlWrapper from 'sinoui-components/Form/FormControl/FormControlWrapper';
import FormControlContent from 'sinoui-components/Form/FormControl/FormControlContent';
import memoize from 'lodash/memoize';
import FormItemError from './FormItemError';
import FormItemLabel from './FormItemLabel';
export var StyledFormItemLabel = styled(FormItemLabel)(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  padding-top: 12px;\n  padding-bottom: 0px;\n  ", ";\n"], ["\n  padding-top: 12px;\n  padding-bottom: 0px;\n  ", ";\n"])), function (props) { return props.vertical && 'display:block;'; });
var StyledFormControlContent = styled(FormControlContent)(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["\n  padding-bottom: 0px;\n  align-self: flex-end;\n"], ["\n  padding-bottom: 0px;\n  align-self: flex-end;\n"])));
/**
 * 获取标签配置
 *
 * @param {any} children
 * @returns
 */
var getLabel = memoize(function (children) {
    var label;
    var props;
    // tslint:disable-next-line:no-any
    React.Children.forEach(children, function (comp) {
        if (comp && comp.type && comp.type.displayName === 'Label') {
            label = comp.props.children;
            /* eslint prefer-destructuring: 0 */
            props = comp.props;
        }
    });
    return { label: label, props: props };
});
var getFormControlProps = memoize(function (children) {
    var formControlProps = {};
    // tslint:disable-next-line:no-any
    React.Children.forEach(children, function (comp) {
        if (comp && comp.props && comp.props.name) {
            formControlProps = comp.props;
        }
    });
    return formControlProps;
});
/**
 * 渲染标签
 */
function renderLabel(label, children, 
// tslint:disable-next-line:no-any
labelProps) {
    if (label && typeof label === 'string') {
        return React.createElement(StyledFormItemLabel, tslib_1.__assign({}, labelProps), label);
    }
    else if (label) {
        return label;
    }
    var _a = getLabel(children), title = _a.label, props = _a.props;
    if (title) {
        var finalTitle = void 0;
        var _props = tslib_1.__assign({}, props);
        var propsTitle = props.title, _b = props.style, propsStyle = _b === void 0 ? {} : _b;
        if (typeof propsTitle === 'function') {
            var name_1 = labelProps.name;
            finalTitle = propsTitle(name_1);
            // 如果有对比的差异，变更label的颜色，暂时先写死，后期调整
            if (!!finalTitle) {
                _props.style = tslib_1.__assign({}, propsStyle, { color: '#f44336' });
            }
        }
        else {
            finalTitle = propsTitle;
        }
        return (React.createElement(StyledFormItemLabel, tslib_1.__assign({}, labelProps, _props, { title: finalTitle }), title));
    }
    return null;
}
/**
 * 表单项组件。
 */
var FormItem = /** @class */ (function (_super) {
    tslib_1.__extends(FormItem, _super);
    function FormItem(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            focused: false,
        };
        _this.onFocus = _this.onFocus.bind(_this);
        _this.onBlur = _this.onBlur.bind(_this);
        return _this;
    }
    FormItem.prototype.onFocus = function () {
        this.setState({ focused: true });
    };
    FormItem.prototype.onBlur = function () {
        this.setState({ focused: false });
    };
    FormItem.prototype.render = function () {
        var _a = this.props, label = _a.label, requiredProp = _a.required, disabledProp = _a.disabled, readOnlyProp = _a.readOnly, nameProp = _a.name, children = _a.children, _b = _a.errorMessageType, errorMessageType = _b === void 0 ? 'normal' : _b, props = tslib_1.__rest(_a, ["label", "required", "disabled", "readOnly", "name", "children", "errorMessageType"]);
        var _c = this.context.sinouiForm, sinouiForm = _c === void 0 ? {} : _c;
        var focused = this.state.focused;
        var name = nameProp || getFormControlProps(children).name;
        var readOnly = readOnlyProp || getFormControlProps(children).readOnly;
        var required = props.requiredByReadOnly
            ? !readOnly
                ? requiredProp || getFormControlProps(children).required
                : false
            : requiredProp || getFormControlProps(children).required;
        var disabled = disabledProp || getFormControlProps(children).disabled;
        var inline = sinouiForm.inline || props.inline;
        var vertical = sinouiForm.vertical || props.vertical;
        var labelWidth = (getLabel(children).props && getLabel(children).props.width) ||
            (sinouiForm.labelProps && sinouiForm.labelProps.width) ||
            '120px';
        var helpTextLeft = sinouiForm.vertical ? '0px' : labelWidth;
        // TODO: 获取焦点时，label颜色变换
        return (React.createElement(React.Fragment, null,
            React.createElement(FormControlWrapper, { className: classNames('sinoui-form-item', {
                    'sinoui-form-item__inline': this.props.inline,
                }, this.props.className), inline: inline, vertical: vertical, style: this.props.style },
                renderLabel(label, children, {
                    name: name,
                    required: required,
                    disabled: disabled,
                    readOnly: readOnly,
                    focused: focused,
                    inline: inline,
                    vertical: vertical,
                }),
                React.createElement(StyledFormControlContent, { className: "sinoui-form-item__content", style: this.props.contentStyle }, React.Children.map(children, function (child) {
                    if (React.isValidElement(child)) {
                        // tslint:disable-next-line:no-any
                        return React.cloneElement(child, { readOnly: readOnly });
                    }
                    return child;
                }))),
            !inline && (React.createElement(FormItemError, { name: name, errorMessageType: errorMessageType, paddingLeft: helpTextLeft }))));
    };
    FormItem.contextTypes = {
        sinouiForm: PropTypes.object,
    };
    return FormItem;
}(React.Component));
export default FormItem;
var templateObject_1, templateObject_2;
//# sourceMappingURL=FormItem.js.map